// Modelos para el sistema de puntos de viajes de incentivo
import { Supplier } from './regla-rappel.model';

/**
 * Type alias para proveedores en el contexto de Points
 * Extiende el Supplier base pero con id numérico para compatibilidad con la API de Points
 */
export interface PointSupplier extends Omit<Supplier, 'id'> {
    id: number;
}

/**
 * Enum para los tipos de taller en el plan rappel
 */
export enum RappelPlanType {
    ALL = 0,            // Todos los talleres
    POINT_S = 1,        // Solo talleres Point S
    POINT_S_EXPRESS = 2 // Solo talleres Point S Express
}

/**
 * Labels para mostrar en la UI
 */
export const RAPPEL_PLAN_LABELS: Record<RappelPlanType, string> = {
    [RappelPlanType.ALL]: 'Todos los talleres',
    [RappelPlanType.POINT_S]: 'Solo talleres Point S',
    [RappelPlanType.POINT_S_EXPRESS]: 'Solo talleres Point S Express'
};

/**
 * Interface para crear/editar un punto
 */
export interface IncentiveTravelPointRequest {
    providerId: number;
    brand: string;
    minimumQuantity: number;
    points: number;
    rappelPlan: RappelPlanType;
    acceptedMeasures: number[];
    centerGroupId: number;
}

/**
 * Interface para un punto completo (con ID)
 */
export interface IncentiveTravelPoint extends IncentiveTravelPointRequest {
    id: number;
    pointsSystemTyresId?: string; // UUID original del backend
    providerName?: string; // Nombre del proveedor para facilitar la edición
    createdAt?: Date;
    updatedAt?: Date;
}

/**
 * Interface para la respuesta del backend (formato real)
 */
export interface IncentiveTravelPointApiResponse {
    pointsSystemTyresId: string;
    brand: string;
    minimumQuantity: number;
    points: number;
    acceptedMeasures: number[];
    providerName: string | null;
    rappelPlan: number;
    centerGroupId: number;
}

/**
 * Interface para el formulario de puntos
 */
export interface IncentiveTravelPointFormData {
    providerId: number;
    brand: string;
    minimumQuantity: number;
    points: number;
    rappelPlan: RappelPlanType;
    acceptedMeasures: number[];
}

/**
 * Interface para la respuesta de la API de puntos
 */
export interface IncentiveTravelPointsResponse {
    points: IncentiveTravelPoint[];
    total: number;
    page: number;
    limit: number;
}

/**
 * Interface para filtros de búsqueda de puntos
 */
export interface IncentiveTravelPointsFilter {
    brand?: string;
    rappelPlan?: RappelPlanType;
    minPoints?: number;
    maxPoints?: number;
}

/**
 * Interface para medidas de neumáticos (RIM)
 */
export interface TireMeasure {
    id: number;
    size: string;
    rim: number;
    label: string;
}

/**
 * Medidas estándar de neumáticos (RIM)
 */
export const TIRE_MEASURES: TireMeasure[] = [
    { id: 13, label: '13"', size: '13', rim: 13 },
    { id: 14, label: '14"', size: '14', rim: 14 },
    { id: 15, label: '15"', size: '15', rim: 15 },
    { id: 16, label: '16"', size: '16', rim: 16 },
    { id: 17, label: '17"', size: '17', rim: 17 },
    { id: 18, label: '18"', size: '18', rim: 18 },
    { id: 19, label: '19"', size: '19', rim: 19 },
    { id: 20, label: '20"', size: '20', rim: 20 },
    { id: 21, label: '21"', size: '21', rim: 21 },
    { id: 22, label: '22"', size: '22', rim: 22 },
    { id: 23, label: '23"', size: '23', rim: 23 },
    { id: 24, label: '24"', size: '24', rim: 24 }
];

/**
 * Opciones comunes para el desplegable de tipo de taller
 */
export const RAPPEL_PLAN_OPTIONS = [
    { value: RappelPlanType.ALL, label: RAPPEL_PLAN_LABELS[RappelPlanType.ALL] },
    { value: RappelPlanType.POINT_S, label: RAPPEL_PLAN_LABELS[RappelPlanType.POINT_S] },
    { value: RappelPlanType.POINT_S_EXPRESS, label: RAPPEL_PLAN_LABELS[RappelPlanType.POINT_S_EXPRESS] }
];